module.exports = __webpack_public_path__ + "img/cover.a9cf297b.jpg";